import { Layout } from "antd"

const Loader = () => {
	return (
		<Layout style={{ minHeight: '100vh' }}>
			</Layout>
	)
}

export default Loader
